"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Item = _interopRequireDefault(require("./Item"));

var _Section = _interopRequireDefault(require("./Section"));

var _SelectedItems = _interopRequireDefault(require("./SelectedItems"));

var _DarkFilter = require("./DarkFilter.style");

var _DarkSquareBorderButton = _interopRequireDefault(require("../Button/DarkSquareBorderButton"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _ = require("..");

var _DarkButton = _interopRequireDefault(require("../Button/DarkButton"));

var _class, _class2, _temp;

var DarkFilter = (0, _emotionTheming.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DarkFilter, _PureComponent);

  function DarkFilter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DarkFilter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DarkFilter).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onOptionChange", function (option, isRemove) {
      var _this$props = _this.props,
          onChangeHandler = _this$props.onChangeHandler,
          type = _this$props.type;
      var selectedOptions = _this.state.selectedOptions;

      if (isRemove) {
        for (var i = 0; i < selectedOptions.length; i += 1) {
          if (selectedOptions[i].itemId === option.itemId) {
            selectedOptions.splice(i, 1);
          }
        }
      } else {
        selectedOptions.push({
          itemId: option.itemId,
          label: option.label,
          genre: option.genre
        });
      }

      _this.setState({
        selectedOptions: selectedOptions
      });

      if (type === 'desktop') {
        _this.forceUpdate();

        onChangeHandler(selectedOptions);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onApplyOptions", function () {
      var _this$props2 = _this.props,
          onChangeHandler = _this$props2.onChangeHandler,
          onCloseClick = _this$props2.onCloseClick;
      var selectedOptions = _this.state.selectedOptions;
      onChangeHandler(selectedOptions);
      onCloseClick();
    });
    _this.state = {
      selectedOptions: props.selectedKeys
    };
    return _this;
  }

  (0, _createClass2.default)(DarkFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          theme = _this$props3.theme,
          onCloseClick = _this$props3.onCloseClick,
          type = _this$props3.type,
          selectedKeys = _this$props3.selectedKeys,
          title = _this$props3.title,
          isFilterOpen = _this$props3.isFilterOpen;
      var selectedOptions = this.state.selectedOptions;

      var childrenWithProps = _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          type: type,
          selectedKeys: selectedKeys,
          onChangeHandler: _this2.onOptionChange.bind(_this2)
        });
      });

      if (type === 'desktop') {
        if (!isFilterOpen) {
          return _react.default.createElement(_SelectedItems.default, {
            selectedOptions: selectedOptions,
            onChangeHandler: this.onOptionChange.bind(this)
          });
        }

        return _react.default.createElement("div", {
          className: (0, _classnames.default)(className, _DarkFilter.rootStyleDesktop)
        }, _react.default.createElement("div", {
          onClick: onCloseClick,
          role: "presentation"
        }, _react.default.createElement(_Icon.default, {
          type: "close",
          className: _DarkFilter.iconStyleDesktop
        })), _react.default.createElement("div", {
          className: _DarkFilter.contentStyleDesktop
        }, childrenWithProps));
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, _DarkFilter.rootStyleMobile)
      }, _react.default.createElement("div", {
        className: _DarkFilter.headerStyle
      }, _react.default.createElement(_DarkButton.default.IconButton, {
        onClick: onCloseClick
      }, _react.default.createElement(_Icon.default, {
        type: "close",
        className: _DarkFilter.iconStyleMobile
      })), _react.default.createElement(_.DarkText, {
        fontSize: 18
      }, title)), _react.default.createElement("div", {
        className: _DarkFilter.contentStyleMobile
      }, childrenWithProps), _react.default.createElement("div", {
        className: _DarkFilter.buttonsContainer
      }, _react.default.createElement(_DarkSquareBorderButton.default, {
        onClick: onCloseClick,
        style: {
          width: '45%',
          textTransform: 'uppercase'
        }
      }, "Cancel"), _react.default.createElement(_DarkSquareBorderButton.default, {
        type: "filled",
        onClick: this.onApplyOptions,
        style: {
          width: '45%',
          textTransform: 'uppercase'
        }
      }, "Apply")));
    }
  }]);
  return DarkFilter;
}(_react.PureComponent), (0, _defineProperty2.default)(_class2, "Section", _Section.default), (0, _defineProperty2.default)(_class2, "Item", _Item.default), _temp)) || _class;

DarkFilter.propTypes = {
  type: _propTypes.default.string,
  selectedKeys: _propTypes.default.array,
  isFilterOpen: _propTypes.default.bool,
  onChangeHandler: _propTypes.default.func,
  onCloseClick: _propTypes.default.func
};
DarkFilter.defaultProps = {
  type: 'desktop',
  selectedKeys: [],
  isFilterOpen: true,
  onChangeHandler: function onChangeHandler() {},
  onCloseClick: function onCloseClick() {}
};
var _default = DarkFilter;
exports.default = _default;